var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tariff', {
    attrs: {
      "tariffs": _vm.tariffs,
      "objectTariffs": _vm.objectTariffs,
      "profile-tariff": _vm.profileTariff,
      "is-fetched": _vm.tariffsIsFetched
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac59d59","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariff/TariffContainer.vue
// module id = 962
// module chunks = 0